import React, { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { useSelector, useDispatch } from "react-redux";
// Material
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Fade from "@material-ui/core/Fade";
// Redux Actions
import { showSnackbarAction } from "./../../store/Snackbar/SnackbarAction";
// Components
import ImageView from "./../ImageView/ImageView";
// Hooks
import useProduct from "../../CustomHooks/useProduct";
// Styles
import useStyles from "./ProductListItem.style.js";
import { isNull } from "lodash";
import { CURRENCY } from "../../utils/Constants";
import useSortHook from "../../CustomHooks/useSortHook.js";
import moment from "moment";

const ProductListItem = ({
  item,
  inActive = false,
  inActiveReason = null,
  onClick,
  time,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const state = useSelector((state) =>
    state.cart.data.filter((p) => p.itemId === item.itemId)
  );
  const { checkoutDetails } = useSelector((state) => state.cart);
  const [currentTime, setCurrentTime] = useState(moment()); // Initialize current time using moment
  const { getNextAvailableTime, formatDateToCheck } = useSortHook();
  const { getOriginalPrice } = useProduct();
  const openProductView = () => {
    if (!inActive) {
      onClick(item);
    } else {
      dispatch(showSnackbarAction("Item currently Out of Stock", "warning"));
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(moment());
    }, 1000);

    // Clear interval on component unmount
    return () => clearInterval(interval);
  }, []);

  const nextTime = useMemo(() => {
    // const result = getNextAvailableTime(item, currentTime.toDate(), "ITEM");
    const result = getNextAvailableTime(
      item,
      checkoutDetails?.deliveryType === "ASAP"
        ? currentTime.toDate()
        : formatDateToCheck(checkoutDetails?.deliveryTime)
    );
    // console.log("resultttttt", result);

    if (!result?.nextAvailableTime) {
      return null; // No available time
    }

    const nextAvailableMoment = moment(result.nextAvailableTime);
    if (nextAvailableMoment.isBefore(currentTime)) {
      return null; // Time is in the past
    }

    return ` ${nextAvailableMoment.fromNow()}`; // Future time
  }, [item, currentTime]);

  // console.log("time,", time);
  return (
    <Card
      className={clsx(classes.root, inActive && classes.disabled)}
      onClick={openProductView}
    >
      {item.imageUrl.length > 10 && (
        <ImageView
          disabled={inActive ? true : false}
          title={item.label}
          overlayText={item.banner}
          className={classes.cover}
          image={item.imageUrl}
        />
      )}
      <div className={classes.details}>
        <CardContent className={classes.content}>
          <Fade in={true}>
            <Typography className={classes.title} variant="h3">
              {item.label}
            </Typography>
          </Fade>
          {/* {nextTime && (
            <Typography className={classes.countText} variant="caption">
              {`available in ${nextTime} `}
            </Typography>
          )} */}
          <Fade in={true}>
            {/* <Typography
              className={classes.desc}
              variant="body2"
              color="secondary"
            >
              {item?.description}
            </Typography> */}
            <div
              className={classes.desc}
              dangerouslySetInnerHTML={{ __html: item?.description }}
            />
          </Fade>
        </CardContent>
        <CardActions className={classes.bottomContent}>
          {item.tags?.length > 0 && (
            <div className={classes.info}>
              <Fade in={true}>
                <Typography className={classes.infoText} variant="caption">
                  {item.tags?.map((t) => t.tag).join(" - ")}
                </Typography>
              </Fade>
            </div>
          )}
          {/* {nextTime && (
            <Typography className={classes.nxtAvailableTime} variant="caption">
              {`available in ${nextTime} `}
            </Typography>
          )} */}
          <Fade in={true}>
            {inActive ? (
              <Typography className={classes.outOfStockText} variant="caption">
                {!isNull(inActiveReason) && inActiveReason !== "null"
                  ? inActiveReason
                  : "Unavailable"}
              </Typography>
            ) : (
              <div className={classes.priceDiv}>
                {item?.banner_price > 0 && (
                  <Typography
                    className={`${classes.priceText} ${classes.bannerText}`}
                    variant="caption"
                  >
                    {CURRENCY.SIGN}
                    {getOriginalPrice(item?.banner_price)}
                  </Typography>
                )}
                <Typography className={classes.priceText} variant="caption">
                  {CURRENCY.SIGN}
                  {getOriginalPrice(item.sale_price)}
                </Typography>
              </div>
            )}
          </Fade>
        </CardActions>
        {nextTime && (
          <Typography className={classes.countText} variant="caption">
            {`next available in ${nextTime} `}
          </Typography>
        )}
        {state.length > 0 && (
          <Fade in={true}>
            <Typography
              className={classes.countText}
              variant="caption"
            >{`${state.length}`}</Typography>
          </Fade>
        )}
      </div>
    </Card>
  );
};

ProductListItem.propTypes = {
  item: PropTypes.shape({
    imageUrl: PropTypes.string,
    label: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    tags: PropTypes.array,
    sale_price: PropTypes.number.isRequired,
    banner: PropTypes.string,
    onClick: PropTypes.func,
  }),
};

ProductListItem.defaultProps = {
  item: {
    imageUrl: null,
    tags: [],
    banner: null,
    onClick: () => {},
  },
};

export default ProductListItem;
